









































































































































import Vue from "vue";
import auth from "../../../services/auth";
import http from "../../../services/http";
import eventBus from "@/services/eventBus";
import { t } from "@/plugins/i18n";

/** csgenauthtypes.szam: 2 = Google Authenticator, 3 = fix kulcs (backend: TwoFactorAuthType) */
const AUTH_TYPE_AUTHENTICATOR = 2;
const AUTH_TYPE_FIXED_KEY = 3;
const FIXED_KEY_MIN_LENGTH = 8;

export default Vue.extend({
  data: () => ({
    secretKey: '',
    imageData: null as string | null,
    isUserUse2FA: false,
    activeAuthType: 0,
    showConfirm: false,
    authType: AUTH_TYPE_AUTHENTICATOR,
    fixedKey: '',
    fixedKeyConfirm: '',
    saving: false,
  }),

  computed: {
    activeTypeName(): string {
      return this.activeAuthType === AUTH_TYPE_FIXED_KEY ? t('FixKulcs') : t('AuthenticatorAlkalmazas');
    },
    fixedKeyError(): string {
      if (this.authType !== AUTH_TYPE_FIXED_KEY || (!this.fixedKey && !this.fixedKeyConfirm)) {
        return '';
      }
      if (this.fixedKey.trim().length < FIXED_KEY_MIN_LENGTH) {
        return t('AKulcsLegalabb8Karakter');
      }
      if (this.fixedKeyConfirm && this.fixedKey !== this.fixedKeyConfirm) {
        return t('AKetKulcsNemEgyezik');
      }
      return '';
    },
    canSave(): boolean {
      if (this.saving) {
        return false;
      }
      if (this.authType === AUTH_TYPE_FIXED_KEY) {
        return this.fixedKey.trim().length >= FIXED_KEY_MIN_LENGTH && this.fixedKey === this.fixedKeyConfirm;
      }
      return !!this.secretKey;
    },
  },

  async beforeMount() {
      // Csak a típust adja vissza (kulcs nélkül); null, ha nincs 2FA.
      await http.post('login/auth', auth.userID, {
            headers: {
              'Content-Type': 'application/json'
            }
      }).then(response =>{
          if(response.data.data != null){
            this.isUserUse2FA = true;
            this.activeAuthType = response.data.data.authenticationType ?? 0;
          }
      });

      if(this.isUserUse2FA == false){
        await http.get(`https://auth.trufinance.hu/truauthenticator/google/setup?user=${auth.userName}&issuer=TruFinance`).then(response => {
            this.imageData = `data:image/png;base64,${response.data.code}`
            this.secretKey = response.data.secretKey
        });
      }
  },
  methods:{
    pushToMainPage(){
      this.$router.push("/");
    },
    saveTwoFactAuth(){
      if (!this.canSave) {
        return;
      }

      const isFixedKey = this.authType === AUTH_TYPE_FIXED_KEY;
      this.saving = true;

      http.post("users/set-twofactauth",{
        authType: isFixedKey ? AUTH_TYPE_FIXED_KEY : AUTH_TYPE_AUTHENTICATOR,
        userid: auth.userID,
        // fix kulcsnál a backend hash-elve tárolja, authenticatornál a TOTP titkos kulcs megy
        secretKey: isFixedKey ? this.fixedKey.trim() : this.secretKey
      }).then(
        response =>{
          if(response.data.data == "success"){
              eventBus.$emit("success", t("KetfaktorosAutentikacioSikeresenBeallitva"));
              this.$router.push("/");
          } else {
              eventBus.$emit("error", t("KetfaktorosAutentikacioBeallitasaSikertelen"));
          }
        }
      ).finally(() => {
        this.saving = false;
      });
    },
    deleteTwoFactAuth(){
      http.post("users/delete-twofactauth",auth.userID, {
             headers: {
               'Content-Type': 'application/json'
             }
      }).then(
        response =>{
            if(response.data.data == "success"){
              eventBus.$emit("success", t("KetfaktorosAutentikacioTorolve"));
              this.$router.push("/");
          }
        }
      );
    }
  }

});


